import styled from 'styled-components'
import { Button } from '@material-ui/core'
import { Flex } from 'components/common/styles'
import { PRIMARY_TEXT } from 'constants/colors'

export const Label = styled(Flex)`
  margin-bottom: 4px;
  color: ${PRIMARY_TEXT};
  line-height: 20px;
`

export const StyledFormControl = styled.div`
  > div {
    width: 100%;
    margin-bottom: 15px;
  }
`

export const StyledButton = styled(Button)`
  > button {
    margin-top: 15px;
    width: 100%;
  }
`
